import { Typography } from 'antd';
import { ReactNode, useEffect, useState } from 'react';
import { ReactComponent as BackButton } from '../../../Assets/CommonTenant/left.svg';
import styles from './NavigationHeader.module.css';

export type NavigationHeaderProps = {
  header?: string;
  onBack: () => void;
  img?: ReactNode;
  rightContent?: ReactNode;
};

const NavigationHeader = ({ header, onBack, img, rightContent }: NavigationHeaderProps) => {
  const { Text } = Typography;
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 18) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div
      className={styles.backButton}
      style={{
        boxShadow: scrolled ? 'rgba(0, 0, 0, 0.16) 0px 4px 10px' : 'none',
      }}
    >
        <BackButton
          style={{ marginLeft: '20px', color: 'var(--header-colour)' }}
          onClick={() => {
            onBack();
          }}
        />
        {img ? (
          <span className={styles.imageHeader}>{img}</span>
        ) : header ? (
          <Text className={styles.headerTitle}>
            {header}
          </Text>
        ) : null}
        {rightContent && (
          <div className={styles.rightContent}>{rightContent}</div>
        )}
    </div>
  );
};

export default NavigationHeader;
